<template>
    <div class="select-clinic-container">
        <div class="cita-header">
            <div class="titulo">1º Elige el centro al que te gustaría acudir:</div>
        </div>
        <div class="select-clinic">
            <div
                class="card"
                v-for="clinic in clinics"
                :key="clinic.name"
                @click="selectClinic(clinic.value)"
            >
                <div class="card-title">{{ clinic.name }}</div>
                <div class="card-content">
                    <img
                        :src="require('@/assets/img/' + clinic.image)"
                        alt="Clinic Image"
                        class="clinic-image"
                    />
                    <div class="clinic-details">
                        <p>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="map-pin-icon">
                                <path
                                    d="M12 2C8.14 2 5 5.14 5 9c0 4.6 7 13 7 13s7-8.4 7-13c0-3.86-3.14-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"
                                />
                            </svg>
                            <span v-html="clinic.address"></span>
                        </p>
                        <button class="info-button" @click.stop="openModal(clinic)">Mapa</button>
                    </div>
                </div>
                <button class="arrow-button">
                    <span style="font-weight: bold">Continuar</span>
                    <svg
                        class="arrow-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 492.004 492.004"
                        xml:space="preserve"
                    >
                        <path
                            d="M382.678 226.804 163.73 7.86C158.666 2.792 151.906 0 144.698 0s-13.968 2.792-19.032 7.86l-16.124 16.12c-10.492 10.504-10.492 27.576 0 38.064L293.398 245.9l-184.06 184.06c-5.064 5.068-7.86 11.824-7.86 19.028 0 7.212 2.796 13.968 7.86 19.04l16.124 16.116c5.068 5.068 11.824 7.86 19.032 7.86s13.968-2.792 19.032-7.86L382.678 265c5.076-5.084 7.864-11.872 7.848-19.088.016-7.244-2.772-14.028-7.848-19.108z"
                        />
                    </svg>
                </button>
            </div>
        </div>

        <!-- Modal -->
        <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
            <div class="modal-container">
                <div class="modal-content">
                    <h4>{{ selectedClinic.name }}</h4>
                    <iframe
                        :src="selectedClinic.mapUrl"
                        width="100%"
                        height="300"
                        style="border: 0"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                    <p v-html="selectedClinic.address"></p>
                    <button class="close-button" @click="closeModal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            clinics: [
                {
                    name: "Clínica Ferrus&Bratos Arturo Soria",
                    address: "Calle de Caleruega, 102 <br> Madrid",
                    image: "caleruega.jpg",
                    value: 2,
                    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3035.5760789942224!2d-3.6728908!3d40.4778799!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd422ee2b5b7a2c1%3A0x1c2c8c5a2f4c3f1a!2sCalle%20de%20Caleruega%2C%20102%2C%2028033%20Madrid!5e0!3m2!1sen!2ses!4v1620000000000!5m2!1sen!2ses",
                },
                {
                    name: "Clínica Ferrus&Bratos Velazquez",
                    address: "Calle de Velázquez, 58 <br> Madrid",
                    image: "velazquez.jpg",
                    value: 3,
                    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3037.0752767780453!2d-3.6853908!3d40.4278799!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd4228a0b8b8b8b9%3A0x1c2c8c5a2f4c3f1a!2sCalle%20de%20Vel%C3%A1zquez%2C%2058%2C%2028001%20Madrid!5e0!3m2!1sen!2ses!4v1620000000000!5m2!1sen!2ses",
                },
            ],
            showModal: false,
            selectedClinic: null,
        };
    },
    methods: {
        selectClinic(clinic) {
            this.$store.commit("setClinic", clinic);
            this.$router.push({ name: "Tratamiento" });
        },
        openModal(clinic) {
            this.selectedClinic = clinic;
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.selectedClinic = null;
        },
    },
};
</script>

<style scoped>
.select-clinic {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
}

.card {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    margin: 10px;
    width: 100%;
    max-width: 600px;
    cursor: pointer;
    transition: box-shadow 0.3s;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
    position: relative;
}

.card-title {
    margin: 0.7rem;
    font-size: 1rem;
    font-weight: bold;
    width: 100%;
    text-align: center;
    margin: 0.9rem 0;
    color: #2f3e4a;
}
.card:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}

.card-content {
    display: flex;
    width: 100%;
    height: 6rem;
    align-items: center;
}

.clinic-image {
    width: 30%;
    height: 100%;
    object-fit: cover;
    border-radius: 0 8px 0 8px;
}

.clinic-details {
    flex-grow: 1;
    padding: 10px;
    width: 70%;
}

.clinic-details p {
    margin: 0;
    font-size: 0.9rem;
    color: #333;
    display: flex;
    align-items: center;
    line-height: normal;
}

.map-pin-icon {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    fill: #333; /* color del icono */
}

.arrow-button {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: var(--pink-color);
    border: none;
    cursor: pointer;
    padding: 3px 7px 1px;
    transition: background-color 0.3s;
    border-radius: 8px 0 8px;
    width: 35%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 15px;
}

.arrow-button:hover {
    background-color: var(--blue-color);
}

.arrow-icon {
    padding: 2px;
    width: 20px;
    height: 20px;
    fill: white; /* color del icono */
}

.cita-header {
    display: flex;
    align-items: center;
    margin: 20px;
    justify-content: center;
}

.cita-header .titulo {
    font-size: 20px;
    font-weight: bold;
}
.select-clinic-container {
    margin-top: 4rem;
}

@media (min-width: 768px) {
    .select-clinic {
        flex-direction: row;
        justify-content: space-around;
    }
}
.info-button {
    background-color: transparent;
    border: none;
    color: var(--blue-color);
    cursor: pointer;
    padding: 0;
    text-decoration: underline;
    font-size: 16px;
    margin-left: 1.5rem;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-container {
    width: 90%;
    max-width: 800px;
    margin: auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
}

.modal-content {
    background-color: #fff;
    border-radius: 8px;
    max-width: 800px;
    text-align: center;
}

.modal-content p {
    text-align: left;
}

.close-button {
    background-color: var(--pink-color);
    border: none;
    color: #fff;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
}
</style>
